import * as audio from './kernel/audio.js';

export {
    init,
}

const sounds = [
    { name: 'karappo', url: new URL('../sounds/Karappo.mp3', import.meta.url) },
];

function init() {
    return loadSounds();
}

function loadSounds() {
    return Promise.all([
        ...sounds.map(sound => {
            return audio.buffers.load(sound.name, sound.url);
        }),
    ]).then(() => {
        if (DEVMODE) console.log('All sounds loaded');
    });
}
